const OKTA_TESTING_DISABLEHTTPSCHECK =
  process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
const REDIRECT_URI = `${window.apcConfig.cam.REACT_APP_URL}/cam/login/callback`;

const OIDC_CONFIG = {
  oidc: {
    clientId: window.apcConfig.cam.OKTA_CLIENT_ID,
    issuer: window.apcConfig.cam.OKTA_ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ["openid", "profile", "email", "groups", "offline_access"],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
    tokenManager: {
      storage: "localStorage",
      autoRenew: true, // auto renew tokens before expiry
      autoRemove: true, // remove expired tokens automatically
    },
  },
};

export default OIDC_CONFIG;
